// import API from '../utils/api';

const ON_NEW_TOOTH_DATA = 'ON_NEW_TOOTH_DATA';
const ON_UPDATED_TOOTH_DATA = 'ON_UPDATED_TOOTH_DATA';
const ON_UPDATED_TEMP_TOOTH_DATA = 'ON_UPDATED_TEMP_TOOTH_DATA';
const ON_APPLY_TEMP_TOOTH_DATA = 'ON_APPLY_TEMP_TOOTH_DATA';

export const GET_CHARTS = 'GET_CHARTS';
export const GET_CHARTS_SUCCESS = 'GET_CHARTS_SUCCESS';
export const GET_CHARTS_FAILED = 'GET_CHARTS_FAILED';

export const POST_CHARTS = 'POST_CHARTS';
export const POST_CHARTS_SUCCESS = 'POST_CHARTS_SUCCESS';
export const POST_CHARTS_FAILED = 'POST_CHARTS_FAILED';

export const PUT_CHARTS = 'PUT_CHARTS';
export const PUT_CHARTS_SUCCESS = 'PUT_CHARTS_SUCCESS';
export const PUT_CHARTS_FAILED = 'PUT_CHARTS_FAILED';

export const DELETE_CHARTS = 'DELETE_CHARTS';
export const DELETE_CHARTS_SUCCESS = 'DELETE_CHARTS_SUCCESS';
export const DELETE_CHARTS_FAILED = 'DELETE_CHARTS_FAILED';

// GET CHART

export const getCharts = () => ({
    type: GET_CHARTS
});

export const getChartsSuccess = (charts) => ({
    type: GET_CHARTS_SUCCESS,
    charts
});

export const getChartsFailed = () => ({
    type: GET_CHARTS_FAILED
});


// CREATE CHART

export const postCharts = () => ({
    type: POST_CHARTS
});

export const postChartsSuccess = (payload) => ({
    type: POST_CHARTS_SUCCESS,
    payload
});

export const postChartsFailed = () => ({
    type: POST_CHARTS_FAILED
});

// UPDATE CHART

export const putCharts = () => ({
    type: PUT_CHARTS
});

export const putChartsSuccess = (payload) => ({
    type: PUT_CHARTS_SUCCESS,
    payload
});

export const putChartsFailed = () => ({
    type: PUT_CHARTS_FAILED
});


// DELETE CHART

export const deleteCharts = () => ({
    type: DELETE_CHARTS
});

export const deleteChartsSuccess = (payload) => ({
    type: DELETE_CHARTS_SUCCESS,
    payload
});

export const deleteChartsFailed = () => ({
    type: DELETE_CHARTS_FAILED
});




export function onNewToothData(data) {
    return {
        type: ON_NEW_TOOTH_DATA,
        data: data
    }
}

export function onUpdatedToothData(data) {
    return {
        type: ON_UPDATED_TOOTH_DATA,
        data: data
    }
}

export function onApplyTempToothData(data, chartType, callback) {
    return {
        type: ON_APPLY_TEMP_TOOTH_DATA,
        data: data,
        chartType: chartType,
        callback: callback
    }
}

export function onUpdatedTempToothData(data) {
    return {
        type: ON_UPDATED_TEMP_TOOTH_DATA,
        data: data
    }
}

export const getChartsApi = () => (dispatch) => {
    dispatch(getCharts());
};


/** WEBPACK FOOTER **
 ** ./src/actions/charting.js
 **/